import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

export default function AdblockDetected() {
  const [popupClosed, setPopupClosed] = useState(false);
  const [adBlockDetected, setAdBlockDetected] = useState(false);

  useEffect(() => {
    const checkAdBlock = () => {
      const testDiv = document.createElement("div");
      testDiv.innerHTML = "&nbsp;";
      testDiv.className = "adsbox";
      document.body.appendChild(testDiv);

      setTimeout(() => {
        if (testDiv.offsetHeight === 0) {
          setAdBlockDetected(true);
        }
        testDiv.remove();
      }, 1200000);
    };

    checkAdBlock();
  }, []);

  useEffect(() => {
    const checkAdBlock = async () => {
      try {
        await fetch(
          "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",
          { mode: "no-cors" }
        );
      } catch (error) {
        try {
          await fetch("https://static.doubleclick.net/instream/ad_status.js", {
            mode: "no-cors",
          });
        } catch (error) {
          setAdBlockDetected(true);
        }
      }
    };

    checkAdBlock();
  }, []);

  return (
    <>
      {adBlockDetected && !popupClosed && (
        <div className="initialshare-wrapper" style={{ display: "flex" }}>
          <div className="initialshare-content">
            <p>
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={{ color: "grey" }}
                className="closeme"
                onClick={() => setPopupClosed(true)}
              />
            </p>
            <p>Hey there! 😉</p>
            <h3>🚫 AdBlock Detected</h3>
            <p style={{ lineHeight: "1.3" }}>
              Please disable your AdBlocker to support our website. We use
              Google AdSense, which is secure and minimally intrusive.
            </p>
          </div>
        </div>
      )}
      {/* <style jsx>{`
        .adblock-popup {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        .popup-content {
          background: white;
          padding: 20px;
          border-radius: 5px;
          text-align: center;
        }
        button {
          background: #ff5a5f;
          color: white;
          padding: 10px 20px;
          border: none;
          cursor: pointer;
        }
      `}</style> */}
    </>
  );
}
